import "./style.css";

export const FloatPanel = ({ component }) => {
  //const floatPanel = useSelector((state) => state.aplicationConfig.userConfig.floatPanel);

  const Panel = () => {
    return (
      <>
        <div className={`floatPanel slide-left`}>{component}</div>
        <div className="shadow"></div>
      </>
    );
  };

  return <Panel />;
};
